const defaults = { mode: 'random', clockPreset: '30+0', boardSize: 5, botDifficulty: 3 };
function normalize(value) {
  return {
    mode: value?.mode === 'offline' ? 'bot' : ['random', 'friend', 'bot'].includes(value?.mode) ? value.mode : defaults.mode,
    clockPreset: ['10+0', '30+0', '12h'].includes(value?.clockPreset) ? value.clockPreset : defaults.clockPreset,
    boardSize: [5, 8].includes(value?.boardSize) ? value.boardSize : defaults.boardSize,
    botDifficulty: [1, 3, 5].includes(value?.botDifficulty) ? value.botDifficulty : defaults.botDifficulty,
  };
}
function readMatchPreferences(storage, username) {
  try { return normalize(JSON.parse(storage.getItem(`kelimoMatchPreferences:${username}`))); } catch { return Object.assign({}, defaults); }
}
function saveMatchPreferences(storage, username, value) {
  try { storage.setItem(`kelimoMatchPreferences:${username}`, JSON.stringify(normalize(value))); } catch {}
}
module.exports = { readMatchPreferences, saveMatchPreferences, normalize };
